/* eslint-disable */
// import lib(s)
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { notification, Space } from 'antd';

import Grid from '@material-ui/core/Grid';

import history from '../../../legacy/containers/History'
import { ROUTES, PATIENT_FILE_TABS } from '../../../legacy/constants'

import PatientProfileForm from '../../components/PatientProfileForm';
import InsuranceForm from '../../components/InsuranceForm';
import StudyEnrollmentForm from '../../components/StudyEnrollmentForm';
import PhysicianAndPracticeInfoForm from '../../components/PhysicianAndPracticeInfoForm';

import { getAutocomplete } from 'state/reducers/autocomplete/autocompleteActions';
import { idtfPatientEnrollment } from 'legacy/containers/ApiUrls'

// module action to Route 
import { handleOnPatientClick } from '../../../legacy/pages/PatientFile/module';
import { handlepatientEnrollment } from '../../state/PatientEnrollment/PatientEnrollmentActions'

import styles from './PatientEnrollmentForm.css'

const FORMS = {
    PATIENT_PROFILE_FORM: 'PATIENT_PROFILE_FORM',
    INSURANCE_FORM: 'INSURANCE_FORM',
    STUDY_ENROLLMENT_FORM: 'STUDY_ENROLLMENT_FORM',
    PHYSICIAN_PRACTICE_FORM: 'PHYSICIAN_PRACTICE_FORM',
}

const PatientEnrollmentForm = props => {
    const dispatch = useDispatch();
    const isEdit = useSelector(state => state.idtfPatientEnrollment.patientEnrollment.enrollEditMode);
    const patientId = useSelector(state => state.idtfPatientEnrollment.patientEnrollment.enrolledPatientData.id);
    // const me = useSelector(state => state.app.dataSources.me)
    // initial validation is false, so set error as true
    const [patientEnrollmentFormErrorState, setPatientEnrollmentFormState] = useState(true);
    const [patientProfileFormState, setPatientProfileFormState] = useState({ errorState: true, formData: {}, });
    const [insuranceFormFormState, setInsuranceFormFormState] = useState({ errorState: true, formData: {}, });
    const [studyEnrollmentFormState, setStudyEnrollmentFormState] = useState({ errorState: true, formData: {}, });
    const [physicianAndPracticeInfoFormState, setPhysicianAndPracticeInfoFormState] = useState({ errorState: true, formData: {}, });
    const {
        me,
    } = props;

    const parseDate = (date) => {
        // console.log(date)
        let year = date.getFullYear();
        let month = (1 + date.getMonth()).toString();
        month = month.length > 1 ? month : '0' + month;
        let day = date.getDate().toString();
        day = day.length > 1 ? day : '0' + day;
        // console.log(day, month, year)
        return month + '-' + day + '-' + year;
    }

    const parsePhoneNum = (n) => {
        return n && n.replaceAll("-", "");
    }
    const validateForm = (secondaryFormName, state, formData) => {

        switch (secondaryFormName) {
            case FORMS.PATIENT_PROFILE_FORM:
                const tempPFS = { ...patientProfileFormState };
                tempPFS.errorState = state;
                tempPFS.formData = formData;
                setPatientProfileFormState(tempPFS);
                break;
            case FORMS.INSURANCE_FORM:
                const tempIFS = { ...insuranceFormFormState };
                tempIFS.errorState = state;
                tempIFS.formData = formData;
                setInsuranceFormFormState(tempIFS);
                break;
            case FORMS.STUDY_ENROLLMENT_FORM:
                const tempSFS = { ...studyEnrollmentFormState };
                tempSFS.errorState = state;
                tempSFS.formData = formData;
                setStudyEnrollmentFormState(tempSFS);
                // console.log("study enrol =>", formData);
                break;
            case FORMS.PHYSICIAN_PRACTICE_FORM:
                const tempPPFS = { ...studyEnrollmentFormState };
                tempPPFS.errorState = state;
                tempPPFS.formData = formData;
                setPhysicianAndPracticeInfoFormState(tempPPFS);
                break;
            default:
                break;
        }
    }

    // Form Submit 
    const handleSubmit = (e) => {
        e.preventDefault && e.preventDefault()
        if (me && me.data && me.data.teams[0] && me.data.teams[0].id) {
            const data = {
                ...patientProfileFormState.formData,
                ...insuranceFormFormState.formData,
                ...studyEnrollmentFormState.formData,
                ...physicianAndPracticeInfoFormState.formData,
            }
            let result = {
                "customParticipantID": data.customParticipantID,
                "orderingPhysicianMemberID": data.orderingPhysician.id,
                "firstName": data.firstName,
                "lastName": data.lastName,
                "phone": parsePhoneNum(data.phone),
                "implantedDevice": data.implantedDevice,
                "alternatePhone": parsePhoneNum(data.alternatePhone),
                "emergencyContactName": data.emergencyContactName,
                "emergencyContactPhone": parsePhoneNum(data.emergencyContactPhone),
                "referringPhysicianMember": data.referringPhysician,
                "middleName": data.middleName,
                "socialSecurityNumber": data.socialSecurityNumber !== '' ? data.socialSecurityNumber : null,
                "address": {
                    "primaryLine": data.patientAddressLine1,
                    "secondaryLine": data.patientAddressLine2,
                    "city": data.patientCity,
                    "state": data.patientAddressState.code,
                    "postalCode": data.patientZipCode
                },
                "shippingAddress": {
                    "primaryLine": data.shippingAddressLine1,
                    "secondaryLine": data.shippingAddressLine2,
                    "city": data.shippingCity,
                    "state": data.patientAddressShippingState.code,
                    "postalCode": data.shippingZipCode,
                    // "note": data.note
                },
                "primaryInsurance": {
                    "insuranceType": data.primaryInsuranceType.value,
                    "medicareId": data.primaryMedicareID,
                    "insuranceCompanyName": data.primaryInsuranceCompanyName,
                    "insuranceGroup": data.primaryInsuranceGroup,
                    "insuranceAuthorizationNumber": data.primaryInsuranceAuthorizationNumber,
                    "policyHolderName": data.primaryInsuranceHolderName,
                    "policyHolderRelationship": data.primaryInsuranceHolderRelationship.value,
                    "subscriberId": data.primarySubscriberId,
                },
                "secondaryInsurance": {
                    "insuranceType": data.secondaryInsuranceType.value,
                    "medicareId": data.secondaryMedicareID,
                    "insuranceCompanyName": data.secondaryInsuranceCompanyName,
                    "insuranceGroup": data.secondaryInsuranceGroup,
                    "insuranceAuthorizationNumber": data.secondaryInsuranceAuthorizationNumber,
                    "policyHolderName": data.secondaryInsuranceHolderName,
                    "policyHolderRelationship": data.secondaryInsuranceHolderRelationship.value,
                    "subscriberId": data.secondarySubscriberId,
                },
                "dob": parseDate(data.dob),
                "sex": data.sex.value,
                "prescribed": true,
                "icd10Codes": data.icd10Codes,
                "serviceType": data.serviceType.value,
                "device": data.device.value,
                "deviceSerialNumber": data.deviceSerialNumber,
                "enrollmentDate": parseDate(data.enrollmentDate),
                "studyDurationInDays": parseInt(data.studyDurationInDays.value),
                "hookupType": data.hookupType.value,
                "email": data.email,
                "notes": data.note

            }
            dispatch(handlepatientEnrollment(me.data.teams[0].id, result, isEdit, patientId))
        }
    }

    useEffect(() => {
        if (me.data && me.data.teams) {
            dispatch(getAutocomplete()); // Get Ordering Physicians and ICD 10 Codes 
        }
    }, [me.isFetching])

    useEffect(() => {
        // check if all the component's form state is valid (all false), set the main form state to true
        if (!patientProfileFormState.errorState && !insuranceFormFormState.errorState && !studyEnrollmentFormState.errorState && !physicianAndPracticeInfoFormState.errorState) {
            // // console.log('setPatientEnrollmentFormState>>>>', patientProfileFormState, insuranceFormFormState, studyEnrollmentFormState, physicianAndPracticeInfoFormState);
            setPatientEnrollmentFormState(false)
        } else {
            setPatientEnrollmentFormState(true)
        }

    }, [patientProfileFormState, insuranceFormFormState, studyEnrollmentFormState, physicianAndPracticeInfoFormState])

    // const isEdit = (new URLSearchParams(window.location.search)).get('isEdit')
    return (
        <div className={styles.pageContainer}>
            {/* PATIENT_PROFILE_FORM: {patientProfileFormState.errorState ? <b style={{ color: 'red' }}>ERROR</b> : <b style={{ color: 'green' }}>NO ERROR</b>} */}
            <PatientProfileForm
                me={me}
                validateMainForm={validateForm}
                formNameSpace={FORMS.PATIENT_PROFILE_FORM}
            />
            {/* INSURANCE_FORM: {insuranceFormFormState.errorState ? <b style={{ color: 'red' }}>ERROR</b> : <b style={{ color: 'green' }}>NO ERROR</b>} */}
            <InsuranceForm
                me={me}
                validateMainForm={validateForm}
                formNameSpace={FORMS.INSURANCE_FORM}
            />
            {/* STUDY_ENROLLMENT_FORM : {studyEnrollmentFormState.errorState ? <b style={{ color: 'red' }}>ERROR</b> : <b style={{ color: 'green' }}>NO ERROR</b>} */}
            <StudyEnrollmentForm
                me={me}
                validateMainForm={validateForm}
                formNameSpace={FORMS.STUDY_ENROLLMENT_FORM}
            />
            {/* PHYSICIAN_PRACTICE_FORM :  {physicianAndPracticeInfoFormState.errorState ? <b style={{ color: 'red' }}>ERROR</b> : <b style={{ color: 'green' }}>NO ERROR</b>} */}
            <PhysicianAndPracticeInfoForm
                me={me}
                validateMainForm={validateForm}
                formNameSpace={FORMS.PHYSICIAN_PRACTICE_FORM}
            />
            <Grid container spacing={5}>
                <Grid item xs={10}>
                    {/* Empty space as per figma */}
                </Grid>
                <Grid item xs={2}>
                    <button type="button"
                        className={patientEnrollmentFormErrorState ? styles.PrimaryButtonDisabled : styles.PrimaryButton}
                        onClick={handleSubmit}
                        disabled={patientEnrollmentFormErrorState} >
                        Enroll Patient
                    </button>
                </Grid>
                <Grid item xs={10}>
                    {/* Empty space as per figma */}
                </Grid>
            </Grid>
        </div>
    )
}

export default PatientEnrollmentForm



// WEBPACK FOOTER //
// ./src/views/containers/PatientEnrollmentForm/PatientEnrollmentForm.jsx